module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc2-10ed90a414dee62f774f13ec82ee5c0e.jpg";